class FullWidthMedia {
    constructor() {
        this.class = {
            module: '.module-fullwidthmedia',
            parallaxImage: '.parallax-image img',
            video: 'video',
            playPauseButton: '.btn.play-pause',
            playIcon: 'fa-play',
            pauseIcon: 'fa-pause',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        this.initParallaxImages();
        this.initVideoControls();
    }

    initParallaxImages() {
        const modules = document.querySelectorAll(this.class.module);

        if (modules.length === 0) {
            return;
        }

        modules.forEach(module => {
            const images = module.querySelectorAll(this.class.parallaxImage);

            if (images.length > 0) {
                new simpleParallax(images, {
                    overflow: true,
                    orientation: 'down',
                    scale: 1.7,
                    delay: 0,
                });
            }
        });
    }

    initVideoControls() {
        const modules = document.querySelectorAll(this.class.module);

        if (modules.length === 0) {
            return;
        }

        modules.forEach(module => {
            const video = module.querySelector(this.class.video);
            const playPauseButton = module.querySelector(this.class.playPauseButton);

            if (video && playPauseButton) {
                this.updateButtonIcon(video, playPauseButton);

                playPauseButton.addEventListener('click', () => {
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                    this.updateButtonIcon(video, playPauseButton);
                });

                video.addEventListener('play', () => this.updateButtonIcon(video, playPauseButton));
                video.addEventListener('pause', () => this.updateButtonIcon(video, playPauseButton));
            }
        });
    }

    updateButtonIcon(video, button) {
        const playIcon = button.querySelector(`.${this.class.playIcon}`);
        const pauseIcon = button.querySelector(`.${this.class.pauseIcon}`);

        if (playIcon && pauseIcon) {
            if (video.paused) {
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
            } else {
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            }
        }
    }
}

export default new FullWidthMedia();
